import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Trophy } from 'lucide-react';
import api from '../services/api';

interface Promotion {
  id: number;
  nom: string;
  product: {
    nom: string;
  };
}

export default function QuizSelect() {
  const [promotions, setPromotions] = useState<Promotion[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchEligible();
  }, []);

  const fetchEligible = async () => {
    try {
      const res = await api.get('/quiz/eligible-promotions');
      const data = res.data as Promotion[];
      if (data.length === 1) {
        navigate(`/quiz/${data[0].id}`);
        return;
      }
      setPromotions(data);
    } catch (error) {
      console.error('Erreur lors du chargement des quiz:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (promotions.length === 0) {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center">
        <p className="text-green-900 font-semibold">
          🎉 Félicitations ! Vous avez complété avec succès tous les quiz de vos formations.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="bg-white rounded-lg shadow p-6">
        <h1 className="text-2xl font-bold mb-4">Choisissez un quiz</h1>
        <div className="space-y-4">
          {promotions.map((p) => (
            <Link
              key={p.id}
              to={`/quiz/${p.id}`}
              className="flex items-center justify-between p-4 border rounded-lg hover:bg-gray-50"
            >
              <div className="flex items-center">
                <Trophy className="h-5 w-5 text-yellow-500 mr-3" />
                <span className="font-medium">{p.nom} - {p.product.nom}</span>
              </div>
              <span className="text-sm text-gray-500">→</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}